import React from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "../../../../../utils/react-redux-hooks";
import { getTravelDetails } from "../../../../SearchPage/_redux/searchCrud";
import { actions } from "../../../../SearchPage/_redux/searchRedux";
import { useHistory } from "react-router";
import { useMediaQuery } from "react-responsive";
import styled from "styled-components";

const Seat = styled.div`
  min-height: 100%;
  -webkit-transform: translateZ(0);
  -webkit-mask-image: -webkit-radial-gradient(circle, white 100%, black 100%);
`;

const BusSeats = (props) => {
  const [womanStats, setWomanStats] = React.useState(false);
  const [manStats, setManStats] = React.useState(false);
  // const [adultCount, setAdultCount] = React.useState(null);
  // const [childCount, setChildCount] = React.useState(null);

  let { state } = useSelector((state) => ({
    state: state.search,
  }));

  const dispatch = useDispatch();
  const history = useHistory();

  React.useEffect(() => {
    dispatch(actions.setFullSeats([]));

    const passengersCount = history.location.pathname.split("/")[6].split(",");
    const splittedURL = history.location.pathname.split("/");

    dispatch(actions.setAdult(+passengersCount[0] + +passengersCount[1]));

    const srcId = +window.localStorage.getItem("srcId");
    const destId = +window.localStorage.getItem("destId");

    getTravelDetails(srcId, destId, splittedURL[5],+passengersCount[0] + +passengersCount[1]).then((res) => {
      res.data.data.fullSeats.map((el) => {
        const index = res.data.data.carDetails.carSchemaInfo.findIndex((le) => {
          return le.seatNumber === el.seatNumber;
        });
        res.data.data.carDetails.carSchemaInfo[index].isReserved = true;
        res.data.data.carDetails.carSchemaInfo[index].gender = el.gender;
      });
      return dispatch(actions.getAllTravelDetails(res.data.data));
    });
  }, []);

  const bgcHandler = (gender, isNewReserved) => {
    if (gender && !isNewReserved) {
      return "#cecaca";
    } else if (gender && isNewReserved) {
      return "rgb(167, 255, 167)";
    } else {
      return "white";
    }
  };

  const colorAndBorderHandler = (gender, isNewReserved, color) => {
    if (gender && !isNewReserved) {
      return "darkgray";
    } else if (gender && isNewReserved) {
      return "green";
    } else {
      return color;
    }
  };
 
  const seatStyleSetter = (seatClass, gender, isNewReserved, carLocationTypeId) => {
    if (seatClass) {
      switch (seatClass) {
        case 1:
          return {
            color: colorAndBorderHandler(gender, isNewReserved, "orange"),
            border: `2px solid  ${colorAndBorderHandler(
              gender,
              isNewReserved,
              "orange"
            )}`,
            width: "35px",
            height: "35px",
            backgroundColor: carLocationTypeId === 6 ? "rgba(0, 0, 0, 0.38)" : bgcHandler(gender, isNewReserved),
            marginInline: "1px",
            pointerEvents: carLocationTypeId === 6 ? "none" : "",
          };
        case 2:
          return {
            color: colorAndBorderHandler(gender, isNewReserved, "gray"),
            border: `2px solid  ${colorAndBorderHandler(
              gender,
              isNewReserved,
              "darkgray"
            )}`,

            width: "35px",
            height: "35px",
            backgroundColor: carLocationTypeId === 6 ? "rgba(0, 0, 0, 0.38)" : bgcHandler(gender, isNewReserved),
            marginInline: "1px",
            pointerEvents: carLocationTypeId === 6 ? "none" : "",
          };
        case 3:
          return {
            color: colorAndBorderHandler(gender, isNewReserved, "black"),
            border: `2px solid  ${colorAndBorderHandler(
              gender,
              isNewReserved,
              "black"
            )}`,
            width: "35px",
            height: "35px",
            backgroundColor: carLocationTypeId === 6 ? "rgba(0, 0, 0, 0.38)" : bgcHandler(gender, isNewReserved),
            marginInline: "1px",
            pointerEvents: carLocationTypeId === 6 ? "none" : "",
          };
      }
    } else {
      return {
        color: "white",
        border: "2px solid white",
        width: "35px",
        height: "35px",
        display: "none",
        backgroundColor: carLocationTypeId === 6 ? "rgba(0, 0, 0, 0.38)" : bgcHandler(gender, isNewReserved),
        marginInline: "1px",
        pointerEvents: carLocationTypeId === 6 ? "none" : "",
      };
    }
  };

  const genderTitleSetter = (id, seatNum) => {
    switch (id) {
      case 0:
        return (
          <h6 className="mx-auto my-auto" style={{ fontSize: "100%" }}>
            خانم
          </h6>
        );
      case 1:
        return (
          <h6 className="mx-auto my-auto" style={{ fontSize: "100%" }}>
            آقا
          </h6>
        );
      // case 2:
      //   return (
      //     <h6 className="mx-auto my-auto" style={{ fontSize: "100%" }}>
      //       کودک
      //     </h6>
      //   );
      default:
        return (
          <h6 className="mx-auto my-auto" style={{ fontSize: "100%" }}>
            {seatNum}
          </h6>
        );
    }
  };

  const seatPassengerSetter = (id, seatNumber, seatClass, obj) => {
    // گرفتن کپی از استیت برای ویرایش
    const copy = state.travelDetails;
    const seatsCopy = state.fullSeats;
    //چک کردن وجود ضندلی پر شده از قبل و دریافت از سرور یا ایجاد شده از طرف کلاینت
    const isAvailable = copy.fullSeats.filter((el) => {
      return el.seatNumber === seatNumber;
    });
    //شرط گذاشتن برای isAvialable
    if (isAvailable.length === 0 && state.adult > 0) {
      // اگر از قبل وجود نداشت اندیس پارامتر را از استیت کلی در آورده
      const index = copy.carDetails.carSchemaInfo.findIndex((el) => {
        return el.id === id;
      });
      // این مرحله برای حذف یا ایجاد رزرو صندلی است که اگر پارامتر جنسیت نال به تابع داده شده باشد حذف میکند در غیر این صورت ایجاد میکند
      if (seatNumber) {
        dispatch(actions.setAdult(parseFloat(state.adult) - 1));

        const price = state.travelDetails.tripPrice.filter((el) => {
          return el.classId === seatClass;
        });
        dispatch(
          // actions.setTotalPrice(+state.totalPrice + +price[0].seatPrice)
          actions.setTotalPrice(+state.totalPrice + +state.travelDetails?.dynamicPrice)
        );

        seatsCopy.push({ seatNumber });
        dispatch(actions.setFullSeats(seatsCopy));

        copy.carDetails.carSchemaInfo[index].isReserved = true;
        copy.carDetails.carSchemaInfo[index].isNewReserved = true;
        switch (seatClass) {
          case 1: {
            copy.carDetails.carSchemaInfo[index].seatClass = "A";
          }
          case 2: {
            copy.carDetails.carSchemaInfo[index].seatClass = "B";
          }
          case 3: {
            copy.carDetails.carSchemaInfo[index].seatClass = "C";
          }
        }
        // پس از اتمام کار استیت ویرایش شده در این مرحله ست میشود
        return dispatch(actions.getAllTravelDetails(copy));
      } else if (obj.isNewReserved) {
        const price = state.travelDetails.tripPrice.filter((el) => {
          return el.classId === seatClass;
        });
        // dispatch(actions.setTotalPrice(state.totalPrice - price[0].seatPrice));
        dispatch(actions.setTotalPrice(state.totalPrice - state.travelDetails?.dynamicPrice));

        dispatch(actions.setAdult(parseFloat(state.adult + 1)));

        const filtered = seatsCopy.filter((el) => {
          return el.seatNumber !== seatNumber;
        });
        dispatch(actions.setFullSeats(filtered));

        delete copy.carDetails.carSchemaInfo[index].isReserved;
        delete copy.carDetails.carSchemaInfo[index].isNewReserved;
        delete copy.carDetails.carSchemaInfo[index].seatClass;
        // پس از اتمام کار استیت ویرایش شده در این مرحله ست میشود
        return dispatch(actions.getAllTravelDetails(copy));
      }
    } else {
      // اگر از قبل صندلی وجود داشته باشد هیچ عملیاتی را قبول نمیکند
      return false;
    }
  };

  const btnVallidation = (seatNumber, columnId, rowId) => {
    setManStats(true);
    setWomanStats(true);

    const looped = state.travelDetails.carDetails.carSchemaInfo.filter((el) => {
      return (
        (el.columnId === columnId - 1 && el.rowId === rowId) ||
        (el.columnId === columnId + 1 && el.rowId === rowId)
      );
    });

    looped.map((el) => {
      if (el.gender === 1) {
        if (el.isNewReserved) {
          setManStats(true);
          setWomanStats(true);
        } else {
          setManStats(true);
          setWomanStats(false);
        }
      } else if (el.gender === 0) {
        if (el.isNewReserved) {
          setWomanStats(true);
          setManStats(true);
        } else {
          setWomanStats(true);
          setManStats(false);
        }
      } else if (el.gender === 2) {
        setManStats(true);
        setWomanStats(true);
      }
    });
  };

  const isMobile = useMediaQuery({ query: `(max-width: 760px)` });

  const seatValidation = (obj) => {
    return (
      <div
        className={`${!isMobile ? "col-3 px-5" : "col-3 px-1"} ${
          +obj.rowId === 0 ? "d-none" : "d-block"
        }`}
      >
        <div
          className={`${
            obj.seatNumber ? "d-flex" : "d-none"
          } justify-content-center align-items-center rounded`}
          type="button"
          style={seatStyleSetter(
            obj.carSeatId,
            obj.isReserved,
            obj.isNewReserved,
            obj.carLocationTypeId,
          )}
          onClick={() => {
            console.log("aaa", obj)
            if (obj.isNewReserved) {
              localStorage.setItem("seatNumber", obj.seatNumber);
              const price = state.travelDetails.tripPrice.filter((el) => {
                return el.classId === obj.carSeatId;
              });
              const copy = state.travelDetails;
              const index = copy.carDetails.carSchemaInfo.findIndex((el) => {
                return el.id === obj.id;
              });
              const filteredFullSeats = state.fullSeats.filter((el) => {
                return el.seatNumber !== obj.seatNumber;
              });
              dispatch(actions.setFullSeats(filteredFullSeats));
              dispatch(
                // actions.setTotalPrice(state.totalPrice - price[0].seatPrice)
                actions.setTotalPrice(state.totalPrice - state.travelDetails?.dynamicPrice)
              );
              dispatch(actions.setAdult(+state.adult + 1));
              delete copy.carDetails.carSchemaInfo[index].isReserved;
              delete copy.carDetails.carSchemaInfo[index].isNewReserved;
              delete copy.carDetails.carSchemaInfo[index].seatClass;
              // پس از اتمام کار استیت ویرایش شده در این مرحله ست میشود
              return dispatch(actions.getAllTravelDetails(copy));
            } else {
              seatPassengerSetter(obj.id, obj.seatNumber, obj.carSeatId, obj);
            }
          }}
        >
          {obj.isReserved
            ? genderTitleSetter(obj.gender, obj.seatNumber)
            : obj.seatNumber}
        </div>
      </div>
    );
  };

  return (
    <div
      className="bg-white w-100 container-fluid pt-7 p-2"
      style={{
        height: "43rem",
        borderRadius: 20,
        border: "1px solid darkgray",
      }}
    >
      <Seat className="d-flex h-auto flex-wrap">
        {state.travelDetails.length !== 0
          ? state.travelDetails.carDetails.carSchemaInfo.map((el, index) => {
              return seatValidation(el);
            })
          : null}
      </Seat>
    </div>
  );
};

export default BusSeats;
